export const GET_METTING_LIST = "ALLOCATOR@GET_METTING_LIST";
export const GET_METTING_LIST_INIT = "ALLOCATOR@GET_METTING_LIST_INIT";
export const GET_METTING_LIST_SUCCESS = "ALLOCATOR@GET_METTING_LIST_SUCCESS";
export const GET_METTING_LIST_FAILED = "ALLOCATOR@GET_METTING_LIST_FAILED";
